import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { logout } from "./app.slice"; // Adjust path as necessary
import { toast } from "react-toastify";

const getToken = () => {
  return localStorage.getItem("token");
};

const languageType = {
  en: "English",
  ch: "Chinese",
  tu: "Turkish",
  it: "Italian",
  po: "Polish",
  jp: "Japanese",
  hi: "Hindi",
  ar: "Arabic",
  ro: "Romanian",
};

const customFetchBaseQuery = async (args, api, extraOptions) => {
  const lng = localStorage.getItem("lng") || "en";

  // console.log("API Base URL:", process.env.REACT_APP_API_BASE_URL);

  const baseResponse = await fetchBaseQuery({
    baseUrl:
      process.env.REACT_APP_API_BASE_URL ||
      "https://manage.guardstar.tech/api/v1/",
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  })(
    { ...args, params: { ...args.params, lng: languageType[lng] } },
    api,
    extraOptions
  );

  if (baseResponse.error) {
    const status = baseResponse.error.status;

    if (status === 401) {
      localStorage.removeItem("token");
      api.dispatch(logout());
    }

    //toast.error(baseResponse.error.data.message);
  }

  return baseResponse;
};

export const apiService = createApi({
  reducerPath: "api",
  baseQuery: customFetchBaseQuery,
  tagTypes: [
    "compliances",
    "compliance",
    "complianceSubmissions",
    "documentation",
    "restaurants",
    "restaurant",
    "Checklists",
    "ChecklistsByType",
    "Checklist",
    "openChecklistStatus",
    "closeChecklistStatus",
    "hotholdChecklistStatus",
    "weeklyChecklistStatus",
    "monthlyChecklistStatus",
  ],
  endpoints: () => ({}),
});

export default apiService;
